import { ALL_SERVICES, About_Company } from "./HeaderData";

export const Footer_MENU_LIST = [
  {
    title: "Services",
    links: ALL_SERVICES.map((service) => ({
      name: service.title,
      pageId: `/services/${service.pageId}`,
    })),
  },
  {
    title: "Company",
    links: About_Company.map((company) => ({
      name: company.title,
      pageId: `/company/${company.pageId}`,
    })),
  },
  {
    title: "Legal",
    links: [
      { name: "Terms of use", pageId: "/legal/terms" },
      { name: "Privacy policy", pageId: "/legal/privacy" },
      { name: "Cookie policy", pageId: "/legal/cookies" },
    ],
  },
  {
    title: "Resources",
    links: [
      { name: "Offers", pageId: "/offers" },
      { name: "Blogs", pageId: "/resources/blogs" },
      { name: "Press Release", pageId: "/resources/press-release" },
    ],
  },
];

export const ALL_DETAIL_ROUTES_INFO = Footer_MENU_LIST.flatMap(
  (menu) => menu.links,
);
